import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showMyWallets } from "../../../../../redux/wallet/walletActions";
import Empty from "../../../../../assets/images/emptyState/invites.png";

export default function UserCards() {
    const dispatch = useDispatch();
    const { myWallets } = useSelector((state) => state.wallet);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        dispatch(showMyWallets());
    }, [dispatch]);

    return (
        <>
            <div className="w-full">

                <div>
                    <ul className="py-6">
                        {myWallets?.data?.length > 0 ? (
                            myWallets?.data?.map((wallet, key) => (
                                <li
                                    className="border-b border-b-gray-100 grid grid-cols-3"
                                    key={key}
                                >

                                    <div className="py-4 mx-6">
                                        {wallet?.currency_code || "--"}
                                    </div>

                                    <div className="py-4">
                                        <p className=" text-sm sm:text-base font-bold text-gray-500 dark:text-white">
                                            {wallet?.currency_name || "--"}
                                        </p>
                                    </div>

                                    <div className="py-4">
                                        <p className=" text-sm sm:text-base font-bold text-gray-500 dark:text-white">
                                            {wallet?.balance} {wallet?.currency_code || "--"}
                                        </p>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <div className="my-10 mt-20  text-center">
                                <img
                                    src={Empty}
                                    alt="empty state"
                                    className="flex justify-center mx-auto mb-4"
                                />
                                <p className="font-bold mb-2">No Wallet</p>
                                <p className="text-sm text-gray-400">
                                    Your Invite list shows here.
                                </p>
                            </div>
                        )}
                    </ul>
                    {/* <Button.Secondary
                        type="button"
                        title={"Back"}
                        className={"sm:hidden rounded-md mb-8 sm:mb-0 w-full"}
                        onClick={() => navigate("/profile")}
                    /> */}
                </div>

            </div>
        </>
    );
}
